import ReactSlickSlider from 'react-slick';
import './styles.scss';

export default function Slider({ children, withSpace = false, ...props }) {
  const carouselConfig = {
    customPaging: (currentDot) => (
      <div key={Math.random()}>
        <button aria-label={`Slide ${currentDot + 1}`} type="button" />
      </div>
    ),
    ...props,
  };

  return (
    <ReactSlickSlider
      {...carouselConfig}
      className={`custom-slide${withSpace ? '--with-space' : ''}`}
    >
      {children}
    </ReactSlickSlider>
  );
}
